import {Box, Card, CardActions, CardHeader, Grid, Typography} from "@mui/material";
import CardMedia from "@mui/material/CardMedia";
import Button from "@mui/material/Button";
import React, {useState} from "react";
import t from "../../../Utils/Translation";
import {Viewer, Worker} from "@react-pdf-viewer/core";

import {Modal, ModalBody, ModalFooter} from "react-bootstrap";
import ModalHeader from "react-bootstrap/ModalHeader";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import {defaultLayoutPlugin} from "@react-pdf-viewer/default-layout";

const Candidates = (props) => {

    const [modal, setModal] = useState(null);

    const jobAnnouncementUrl = localStorage.getItem("i18n")==="it" ? "https://lykio-dev-data.s3.eu-central-1.amazonaws.com/units/ENI/Videos+for+Comparative+Evaluation+Activity/Annuncio+IRC217703+VALUTAZIONE.pdf": "https://lykio-dev-data.s3.eu-central-1.amazonaws.com/units/ENI/Job+announcement_JuniorR%26DFermentation+(VALUTAZIONE)+ENG.pdf";
    const silvia_cv = localStorage.getItem("i18n")==="it" ? 'https://lykio-dev-data.s3.eu-central-1.amazonaws.com/units/ENI/Videos+for+Comparative+Evaluation+Activity/CV+Silvia+Pastorino.pdf' : "https://lykio-dev-data.s3.eu-central-1.amazonaws.com/units/ENI/_CV+Silvia+Pastorino+ENG+(VALUTAZIONE).pdf";
    const giulia_cv = localStorage.getItem("i18n")==="it" ? 'https://lykio-dev-data.s3.eu-central-1.amazonaws.com/units/ENI/Videos+for+Comparative+Evaluation+Activity/CV+Giulia+Ferrari.pdf' : "https://lykio-dev-data.s3.eu-central-1.amazonaws.com/units/ENI/_CV+Giulia+Ferrari+ENG+(VALUTAZIONE).pdf";
    const bilal_cv = localStorage.getItem("i18n")==="it" ? 'https://lykio-dev-data.s3.eu-central-1.amazonaws.com/units/ENI/Videos+for+Comparative+Evaluation+Activity/CV+Bilal+Hakmi.pdf' : "https://lykio-dev-data.s3.eu-central-1.amazonaws.com/units/ENI/_CV+Bilal+Hakmi+ENG+(VALUTAZIONE).pdf";

    const handleOpen = (id) => {
        setModal(id);
    };

    const handleClose = () => {
        setModal(null);
    };

    const rootStyles = {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
    };
    const gridStyles = {
        width: '80%',
        height: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
    };
    const cardStyles = {
        width: '80%',
        height: '100%',
        justifyContent: 'center',
        alignItems: 'center'
    };

    const transform = (slot) => ({
        ...slot,
        // These slots will be empty
        Open: () => <></>
    });


    const renderToolbar = (Toolbar) => (
        <Toolbar>{renderDefaultToolbar(transform)}</Toolbar>
    )
    const defaultLayoutPluginInstance = defaultLayoutPlugin({renderToolbar,});

    const {renderDefaultToolbar} = defaultLayoutPluginInstance.toolbarPluginInstance

    return (
        <>

            <Button className={' p-2 mx-4'} onClick={() => handleOpen(4)} style={{float: 'right', background: "linear-gradient(to bottom, #006f4b, #006f4b)", color: "white", borderRadius: '10px', fontSize: '24px' }}>{t("Job announcement")}</Button>

            <Grid container  style={rootStyles}>
                <Grid item xs={3} style={gridStyles}>
                    <Card style={cardStyles}>
                        <CardHeader  title={'Silvia'} style={{ background: "linear-gradient(to bottom, #006f4b, #006f4b)", maxWidth: '60%',borderTopRightRadius: '15px'}}/>
                        <CardMedia
                            component="img"
                            alt="Card 1"
                            height="300"
                            image="https://lykio-dev-data.s3.eu-central-1.amazonaws.com/units/ENI/Videos+for+Comparative+Evaluation+Activity/SILVIA.jpeg"
                            title="Card 1"
                        />
                        <CardActions>
                            <Button onClick={() => handleOpen(1)} variant='contained' color={'primary'} style={{background: "linear-gradient(to bottom, #006f4b, #006f4b)"}}> {t("VIEW CV")}</Button>
                        </CardActions>
                    </Card>
                </Grid>
                <Grid item xs={3} style={gridStyles}>
                    <Card style={cardStyles}>
                        <CardHeader  title={'Bilal'} style={{ background: "linear-gradient(to bottom, #006f4b, #006f4b)", maxWidth: '60%', borderTopRightRadius: '15px' }}/>
                        <CardMedia
                            component="img"
                            alt="Card 2"
                            height="300"
                            image="https://lykio-dev-data.s3.eu-central-1.amazonaws.com/units/ENI/Videos+for+Comparative+Evaluation+Activity/BILAL.png"
                            title="Card 2"
                        />
                        <CardActions>
                            <Button onClick={() => handleOpen(2)} variant='contained' color={'primary'} style={{background: "linear-gradient(to bottom, #006f4b, #006f4b)"}}> {t("VIEW CV")}</Button>
                        </CardActions>
                    </Card>
                </Grid>
                <Grid item xs={3} style={gridStyles}>
                    <Card style={cardStyles}>
                        <CardHeader  title={'Giulia'} style={{  background: "linear-gradient(to bottom, #006f4b, #006f4b)", maxWidth: '60%', borderTopRightRadius: '15px' }}/>
                        <CardMedia
                            component="img"
                            alt="Card 3"
                            height="300"
                            image="https://lykio-dev-data.s3.eu-central-1.amazonaws.com/units/ENI/valutazione1/GIULIA_.png"
                            title="Card 3"
                        />
                        <CardActions>
                            <Button variant='contained' onClick={() => handleOpen(3)} color={'primary'} style={{background: "linear-gradient(to bottom, #006f4b, #006f4b)"}}> {t("VIEW CV")}</Button>
                        </CardActions>
                    </Card>
                </Grid>
            </Grid>
            <Box className={'mt-5'} display="flex" justifyContent="center" m={1}>
                <Button variant="contained" color="primary" onClick={props.handleNextStep} style={{ margin: '8px',background: "linear-gradient(to bottom, #006f4b, #006f4b)", color: "white", borderRadius: '10px', fontSize: '24px' }}>
                    {t("PROCEED")}
                </Button>
            </Box>

            {modal === 1 && (
                <Modal show={true} onHide={handleClose} size='xl' >
                    <Modal.Header closeButton>
                        <Modal.Title>Silvia</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Box height={'70vh'} position={'relative'}>
                            <Worker workerUrl="https://unpkg.com/pdfjs-dist@3.1.81/build/pdf.worker.min.js">
                                <div   style={{
                                    height: '100%',
                                    width: '100%'
                                }}>
                                    <Viewer fileUrl={silvia_cv} plugins={[defaultLayoutPluginInstance]} />;
                                </div>
                            </Worker>
                        </Box>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={handleClose}>
                            {t("Close")}
                        </Button>
                    </Modal.Footer>
                </Modal>

            )}
            {modal === 2 && (
                <Modal show={true} onHide={handleClose} size='xl' >
                    <Modal.Header closeButton>
                        <Modal.Title>Bilal</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Box height={'70vh'} position={'relative'}>
                            <Worker workerUrl="https://unpkg.com/pdfjs-dist@3.1.81/build/pdf.worker.min.js">
                                <div   style={{
                                    height: '100%',
                                    width: '100%'
                                }}>
                                    <Viewer fileUrl={bilal_cv} plugins={[defaultLayoutPluginInstance]} />;
                                </div>
                            </Worker>
                        </Box>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={handleClose}>
                            {t("Close")}
                        </Button>
                    </Modal.Footer>
                </Modal>

            )}
            {modal === 3 && (
                <Modal show={true} onHide={handleClose} size='xl' >
                    <Modal.Header closeButton>
                        <Modal.Title>Guilia</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Box height={'70vh'} position={'relative'}>
                            <Worker workerUrl="https://unpkg.com/pdfjs-dist@3.1.81/build/pdf.worker.min.js">

                                <div   style={{
                                    height: '100%',
                                    width: '100%'
                                }}>
                                    <Viewer fileUrl={giulia_cv} plugins={[defaultLayoutPluginInstance]} />;
                                </div>
                            </Worker>
                        </Box>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={handleClose}>
                            {t("Close")}
                        </Button>
                    </Modal.Footer>
                </Modal>
            )}
            {modal === 4 && (
                <Modal show={true} onHide={handleClose} size='xl' >
                    <Modal.Header closeButton>
                        <Modal.Title>{t("Job announcement")}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Box height={'70vh'} position={'relative'}>
                            <Worker workerUrl="https://unpkg.com/pdfjs-dist@3.1.81/build/pdf.worker.min.js">
                                <div   style={{
                                    height: '100%',
                                    width: '100%'
                                }}>
                                    <Viewer fileUrl={jobAnnouncementUrl} plugins={[defaultLayoutPluginInstance]} />;
                                </div>
                            </Worker>
                        </Box>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={handleClose}>
                            {t("Close")}
                        </Button>
                    </Modal.Footer>
                </Modal>
            )}
        </>
    );
}

export default Candidates;